export enum UXFeedbackEvents {
    TRIP_SERVICE_CONFIRM = 'trip_service_confirm',
    TRIP_FEEDBACK_SEND = 'trip_feedback_send',
}
